/**
 * @deprecated This function is deprecated in favor of round.
 */
export const roundTo = (decimalPlaces: number) => (n: number) => parseFloat(n.toFixed(decimalPlaces));
